@if (apiConfig.config) {
  <app-main-template>
    <app-header slot="header"></app-header>
    <app-footer slot="footer"></app-footer>
    <mat-drawer-container [hasBackdrop]="true">
      <mat-drawer-content>
        <router-outlet></router-outlet>
      </mat-drawer-content>
      <mat-drawer
        [opened]="isMobileMenuOpen | async"
        [mode]="'over'"
        (openedChange)="changeMenuState($event)"
        position="end"
        fixedInViewport="true"
      >
        <app-side-header></app-side-header>

      </mat-drawer>
    </mat-drawer-container>
  </app-main-template>
}
